var _defs, _path, _path2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipOperationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Design",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#004bee;stroke-width:0px;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:none;stroke:#004bee;stroke-miterlimit:10;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.33,53.33c-2.24-2.08-3.64-5.04-3.64-8.33s1.4-6.25,3.64-8.33c.6-.56,1.27-1.06,1.98-1.47,2.24-2.08,3.64-5.04,3.64-8.33,0-6.28-5.1-11.37-11.38-11.37s-11.38,5.09-11.38,11.37c0,3.29,1.4,6.25,3.64,8.33.71.42,1.38.91,1.98,1.47,2.24,2.07,3.64,5.04,3.64,8.33s-1.4,6.26-3.64,8.33c-.6.56-1.27,1.05-1.98,1.47-2.24,2.08-3.64,5.04-3.64,8.33,0,6.28,5.09,11.36,11.38,11.36s11.38-5.09,11.38-11.36c0-3.29-1.4-6.26-3.64-8.33-.72-.42-1.38-.91-1.98-1.47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.98,36.7c4.38,0,7.93,3.55,7.93,7.92s-3.55,7.92-7.93,7.92-7.93-3.55-7.93-7.92,3.55-7.92,7.93-7.92"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "57.57 26.04 28.98 44.63 57.57 63.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipOperationsIcon);
export default __webpack_public_path__ + "static/media/HIP Operations Icon.0b9216214f6a6f5bf30b8a0f7f8943cd.svg";
export { ForwardRef as ReactComponent };